import { GridSize } from '@material-ui/core/Grid';
import { CSSProperties } from 'react';

export type RenderType = 'modal' | 'popup';

type Config = {
  formScroll: CSSProperties;
  nameXs: GridSize;
  buttonsXs: GridSize;
};

const config: Record<RenderType, Config> = {
  modal: {
    formScroll: {},
    nameXs: 4,
    buttonsXs: 3
  },
  popup: { formScroll: { overflowY: 'scroll', maxHeight: 300, flexWrap: 'nowrap' }, nameXs: 3, buttonsXs: 4 }
};

export const useFormUiConfig = (renderType: RenderType) => {
  return config[renderType];
};
